import { validateQueryParams } from '../../../../../../utils/api/api-utils';
import {
  doGetQCXRequest, doPostQCXRequest, doPutQCXActivateRequest, doPutQCXInactivateRequest, doPutQCXRequest,
} from '../../../../../../utils/api/domain/domain-api-utils';
import { ETAPA_ENDPOINT, FILTER_ENDPOINT, OCORRENCIA_ENDPOINT } from '../../../../../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    OCORRENCIA_ENDPOINT
  ]);
}

export async function fetchAllByEtapaId(etapaId) {
  return doGetQCXRequest([
    ETAPA_ENDPOINT, etapaId, 'ocorrencias'
  ]);
}

export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      OCORRENCIA_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    OCORRENCIA_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [OCORRENCIA_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [OCORRENCIA_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [OCORRENCIA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [OCORRENCIA_ENDPOINT],
    id
  );
}
